import styled from 'styled-components';
import { Grid, GridItem } from '@lifechurch/react-ion';

export const SignupGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
  grid-row-gap: 24px;
  margin: 48px auto 64px;
  max-width: 1024px;
`;

export const SignupGridItem = styled(GridItem)`
  grid-column: 1 / span 6;
  grid-column-start: 4;

  @media (max-width: 639px) {
    grid-column: span 12;
  }
`;
